export * from './paste-selected'
